import { render, staticRenderFns } from "./archivepayment.vue?vue&type=template&id=cb379392&"
import script from "./archivepayment.vue?vue&type=script&lang=js&"
export * from "./archivepayment.vue?vue&type=script&lang=js&"
import style0 from "./archivepayment.vue?vue&type=style&index=0&id=cb379392&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports